import React from 'react';
import styles from './feedback-question.css'
import { FeedbackHOC } from './questionHOC.jsx';

import backIcon from './back.svg';

class Questionpage extends React.Component {
    constructor() {
        super()
        this.abc = this.abc.bind(this)
    }
    componentDidMount() {
        let link = document.getElementsByClassName('link')[0]
        link && link.addEventListener('click', this.abc)
    }
    componentDidUpdate() {
        let link = document.getElementsByClassName('link')[0]
        link && link.removeEventListener('click', this.abc)
        link && link.addEventListener('click', this.abc)
    }
    getLink(value) {
        let { title, content } = value
        let table = "<table><thead>"
        table += "<tr><th class='question-th'>" + title + "</th></tr>"
        table += "</thead><tbody>" + content + "</tbody>"
        table += "</table>"

        let regexp = /@link\d+@link/ig
        let regexp2 = /%2[\w\u4e00-\u9fa5：‘’，。、；':“”"<>= \-\/①②③④⑤⑥⑦\.,]*%2/ig
        let regexp3 = /%3[\w\u4e00-\u9fa5：‘’，。、；':“”"<>= \-\/①②③④⑤⑥⑦\.,]*%3/ig
        let regexp4 = /%4[\w\/:\.-]*%4/ig

        let str = table.match(regexp)
        if (str) {
            for (let i = 0; i < str.length; i++) {
                let num = str[i].replace(/@link/ig, "")
                let items = this.props.getItem(num)
                if (items.length == 0) {
                    table = table
                } else {
                    table = table.replace(str[i], `<a class="link" data-ID=${items[0].id}>${items[0].title}</a>`)
                }
            }
        }

        let str2 = table.match(regexp2)
        if (str2) {
            for (let i = 0; i < str2.length; i++) {
                let newStr = str2[i].replace(/%2/ig, "")
                table = table.replace(str2[i], `<tr><th>${newStr}</th></tr>`)
            }
        }


        let str3 = table.match(regexp3)
        if (str3) {
            for (let i = 0; i < str3.length; i++) {
                let newStr = str3[i].replace(/%3/ig, "")
                table = table.replace(str3[i], `<tr><td class="question-td"><span>${newStr}</span></td></tr>`)
            }
        }

        let str4 = table.match(regexp4)
        if (str4) {
            for (let i = 0; i < str4.length; i++) {
                let newStr = str4[i].replace(/%4/ig, "")
                table = table.replace(str4[i], `<tr><td class="question-td"><img class="questImg" src="${newStr}" alt="${newStr}" /></td></tr>`)
            }
        }

        return table
    }
    componentWillUnmount() {
        let link = document.getElementsByClassName('link')[0]
        link && link.removeEventListener('click', this.abc)
    }
    abc(e) {
        this.props.handleShow(this.props.getItem(e.target.getAttribute('data-ID'))[0])
    }
    render() {
        const {
            lastHostory,
            goback
        } = this.props
        const data = lastHostory()
        return (
            <div className={styles.questionContainer1}>
                <div className={styles.questionNavbar}>
                    <div className={styles.backBtn}>
                        <img src={backIcon} alt="" draggable={false} onClick={goback} />
                    </div>
                </div>
                <div className={styles.containersBox} dangerouslySetInnerHTML={{ __html: this.getLink(data) }}></div>
            </div>
        )
    }
}
const Questionpages = FeedbackHOC(Questionpage)

export default Questionpages